
const EMBED_MODE_PREFIX = '/embed';
export function isEmbedMode(location) {
    return location.pathname.startsWith(EMBED_MODE_PREFIX)
}